module.exports = __webpack_public_path__ + "static/img/leisure-main-img.18452665.png";